"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
// TODO: use this in radio button group
exports.useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        container: function (_a) {
            var multilineBox = _a.multilineBox;
            return ({
                margin: multilineBox ? 0 : '16px 0',
            });
        },
        content: function (_a) {
            var multilineBox = _a.multilineBox;
            return ({
                marginBottom: multilineBox ? 20 : 24,
            });
        },
        header: function (_a) {
            var multilineBox = _a.multilineBox, thinHeader = _a.thinHeader, color = _a.color;
            return ({
                textTransform: 'uppercase',
                color: color === 'grey' ? themes_1.materialColors.grey[500] : theme.palette.primary.main,
                // eslint-disable-next-line no-nested-ternary
                marginBottom: multilineBox ? 0 : thinHeader ? 8 : 16,
            });
        },
    });
});
